import { atom } from "recoil"
import { ATOMS_KEYS } from "../atom-keys"

export const isMonthlyView = atom<"1" | "0">({
	key: ATOMS_KEYS.ISMONTHLYVIEW,
	default: "0",
})
